import { useMutation } from '@apollo/client';
import { graphql } from '@app/graphql/types';

export const QUERY = graphql(`
    mutation CancelOnlineOrderWaitingPayment($onlineOrderID: ID!) {
        storefront_onlineOrder_waitingPayment_cancel(onlineOrderID: $onlineOrderID)
    }
`);

export function useOnlineOrderWaitingPaymentCancel() {
  return useMutation(QUERY, {refetchQueries: ['OnlineOrderDetailPage']});
} 